import CRUD from './genericCRUD'

const route = 'target_markets'
/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function targetMarkets(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllPaged: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`${route}/page${params}`, config)
		}
	}
}
